import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { DateRangeFieldComponent } from './date-range-field/date-range-field.component';
import { DateRangePickerComponent } from './date-range-picker/date-range-picker.component';
import { DateRangePickerModalService } from './date-range-picker-modal/date-range-picker-modal.service';
import { DateRangePickerModalComponent } from './date-range-picker-modal/date-range-picker-modal.component';
import { AngularPipesModule } from '@aptitude/angular-pipes';

@NgModule({
  declarations: [
    DateRangeFieldComponent,
    DateRangePickerComponent,
    DateRangePickerModalComponent,
  ],
  imports: [AngularPipesModule, CommonModule, NgbModalModule],
  exports: [
    DateRangeFieldComponent,
    DateRangePickerComponent,
    DateRangePickerModalComponent,
  ],
  providers: [DateRangePickerModalService],
})
export class DateRangeModule {}
